export default function getRandomId(): string {
  return Math.random().toString(16).split('.')[1].slice(0, 10);
}
